var map = {
	"./Uplayplus_LP_carousel_ACOD_desktop.png": 104,
	"./Uplayplus_LP_carousel_ACOD_desktop.webp": 22,
	"./Uplayplus_LP_carousel_ACOD_mobile.png": 105,
	"./Uplayplus_LP_carousel_ACOD_mobile.webp": 23,
	"./Uplayplus_LP_carousel_ACV_desktop.png": 106,
	"./Uplayplus_LP_carousel_ACV_desktop.webp": 24,
	"./Uplayplus_LP_carousel_ACV_mobile.png": 107,
	"./Uplayplus_LP_carousel_ACV_mobile.webp": 25,
	"./Uplayplus_LP_carousel_Anno1800_desktop.png": 108,
	"./Uplayplus_LP_carousel_Anno1800_desktop.webp": 26,
	"./Uplayplus_LP_carousel_Anno1800_mobile.png": 109,
	"./Uplayplus_LP_carousel_Anno1800_mobile.webp": 27,
	"./Uplayplus_LP_carousel_FC5_desktop.png": 110,
	"./Uplayplus_LP_carousel_FC5_desktop.webp": 28,
	"./Uplayplus_LP_carousel_FC5_mobile.png": 111,
	"./Uplayplus_LP_carousel_FC5_mobile.webp": 29,
	"./Uplayplus_LP_carousel_FCND_desktop.png": 112,
	"./Uplayplus_LP_carousel_FCND_desktop.webp": 30,
	"./Uplayplus_LP_carousel_FCND_mobile.png": 113,
	"./Uplayplus_LP_carousel_FCND_mobile.webp": 31,
	"./Uplayplus_LP_carousel_FH_desktop.png": 114,
	"./Uplayplus_LP_carousel_FH_desktop.webp": 32,
	"./Uplayplus_LP_carousel_FH_mobile.png": 115,
	"./Uplayplus_LP_carousel_FH_mobile.webp": 33,
	"./Uplayplus_LP_carousel_GRBP_desktop.png": 116,
	"./Uplayplus_LP_carousel_GRBP_desktop.webp": 34,
	"./Uplayplus_LP_carousel_GRBP_mobile.png": 117,
	"./Uplayplus_LP_carousel_GRBP_mobile.webp": 35,
	"./Uplayplus_LP_carousel_IFR_desktop.png": 118,
	"./Uplayplus_LP_carousel_IFR_desktop.webp": 36,
	"./Uplayplus_LP_carousel_IFR_mobile.png": 119,
	"./Uplayplus_LP_carousel_IFR_mobile.webp": 37,
	"./Uplayplus_LP_carousel_PoPFS_desktop.png": 120,
	"./Uplayplus_LP_carousel_PoPFS_desktop.webp": 38,
	"./Uplayplus_LP_carousel_PoPFS_mobile.png": 121,
	"./Uplayplus_LP_carousel_PoPFS_mobile.webp": 39,
	"./Uplayplus_LP_carousel_R6S_desktop.png": 122,
	"./Uplayplus_LP_carousel_R6S_desktop.webp": 40,
	"./Uplayplus_LP_carousel_R6S_mobile.png": 123,
	"./Uplayplus_LP_carousel_R6S_mobile.webp": 41,
	"./Uplayplus_LP_carousel_SCblacklist_desktop.png": 124,
	"./Uplayplus_LP_carousel_SCblacklist_desktop.webp": 42,
	"./Uplayplus_LP_carousel_SCblacklist_mobile.png": 125,
	"./Uplayplus_LP_carousel_SCblacklist_mobile.webp": 43,
	"./Uplayplus_LP_carousel_TC2_desktop.png": 126,
	"./Uplayplus_LP_carousel_TC2_desktop.webp": 44,
	"./Uplayplus_LP_carousel_TC2_mobile.png": 127,
	"./Uplayplus_LP_carousel_TC2_mobile.webp": 45,
	"./Uplayplus_LP_carousel_TCTD2_desktop.png": 128,
	"./Uplayplus_LP_carousel_TCTD2_desktop.webp": 46,
	"./Uplayplus_LP_carousel_TCTD2_mobile.png": 129,
	"./Uplayplus_LP_carousel_TCTD2_mobile.webp": 47,
	"./Uplayplus_LP_carousel_TrialsRising_desktop.png": 130,
	"./Uplayplus_LP_carousel_TrialsRising_desktop.webp": 48,
	"./Uplayplus_LP_carousel_TrialsRising_mobile.png": 131,
	"./Uplayplus_LP_carousel_TrialsRising_mobile.webp": 49,
	"./Uplayplus_LP_carousel_WDL_desktop.png": 132,
	"./Uplayplus_LP_carousel_WDL_desktop.webp": 50,
	"./Uplayplus_LP_carousel_WDL_mobile.png": 133,
	"./Uplayplus_LP_carousel_WDL_mobile.webp": 51,
	"./blueIcon.png": 134,
	"./blueIcon.webp": 52,
	"./bronze_badge.png": 135,
	"./bronze_badge.webp": 53,
	"./bronze_badge_mobile.png": 136,
	"./bronze_badge_mobile.webp": 54,
	"./cut_reward_icon.png": 137,
	"./cut_reward_icon.svg": 138,
	"./cut_reward_icon.webp": 55,
	"./full_reward_icon.png": 139,
	"./full_reward_icon.svg": 140,
	"./full_reward_icon.webp": 56,
	"./gold_badge.png": 141,
	"./gold_badge.webp": 57,
	"./gold_badge_mobile.png": 142,
	"./gold_badge_mobile.webp": 58,
	"./greenIcon.png": 143,
	"./greenIcon.webp": 59,
	"./keep_rewards_icons.png": 144,
	"./keep_rewards_icons.webp": 60,
	"./left_arrow.svg": 145,
	"./platinum_badge.png": 146,
	"./platinum_badge.webp": 61,
	"./platinum_badge_mobile.png": 147,
	"./platinum_badge_mobile.webp": 62,
	"./progress_bar_arrow.svg": 148,
	"./redeem_reward_images_desktop.png": 149,
	"./redeem_reward_images_desktop.webp": 63,
	"./redeem_reward_images_mobile.png": 150,
	"./redeem_reward_images_mobile.webp": 64,
	"./rewards_video_image.png": 151,
	"./rewards_video_image.webp": 65,
	"./right_arrow.svg": 152,
	"./silver_badge.png": 153,
	"./silver_badge.webp": 66,
	"./silver_badge_mobile.png": 154,
	"./silver_badge_mobile.webp": 67,
	"./ubisoftPlusLogo.svg": 155,
	"./valhala_fenyx_rysing_background_desktop.jpg": 156,
	"./valhala_fenyx_rysing_background_desktop.webp": 68,
	"./valhala_fenyx_rysing_background_mobile.jpg": 157,
	"./valhala_fenyx_rysing_background_mobile.webp": 69,
	"./valhala_fenyx_rysing_background_tablet.jpg": 158,
	"./valhala_fenyx_rysing_background_tablet.webp": 70,
	"./video_close_icon.svg": 159,
	"./yellowIcon.png": 160,
	"./yellowIcon.webp": 71
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14;